import { FirstLevelAccountPrompt } from "#first-level-account-prompt";
import { ReviewCompletionCelebration } from "#review-completion-celebration";
import { useFirstLevelAccountPromptGate } from "#use-first-level-account-prompt-gate";
import { useReviewCompletionCelebrationGate } from "#use-review-completion-celebration-gate";

/**
 * Learn-wide overlays that appear on their own schedule (a finished review session, a guest's
 * first-level milestone). Their gates read the Learn layout context, so this host renders inside
 * `LearnLayoutContextProvider` and decides which overlays mount.
 */
export function LearnLayoutPrompts() {
  const reviewCompletionCelebrationGate = useReviewCompletionCelebrationGate();
  const firstLevelAccountPromptGate = useFirstLevelAccountPromptGate();

  return (
    <>
      {reviewCompletionCelebrationGate !== null && (
        <ReviewCompletionCelebration gate={reviewCompletionCelebrationGate} />
      )}
      {firstLevelAccountPromptGate !== null && (
        <FirstLevelAccountPrompt gate={firstLevelAccountPromptGate} />
      )}
    </>
  );
}
